import Link from "next/link";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { createExcerpt } from "@/lib/blog/content";

type BlogPostCardItem = {
  id: string;
  slug: string;
  title: string;
  meta_description: string | null;
  content_markdown: string;
  image_url: string | null;
  tags: string[];
  published_at: string | Date;
};

type BlogPostCardProps = {
  post: BlogPostCardItem;
};

export function BlogPostCard({ post }: BlogPostCardProps) {
  const excerpt = createExcerpt(
    post.meta_description ?? post.content_markdown,
    180,
  );

  return (
    <Link href={`/blog/${post.slug}`} className="hover:text-primary">
      <Card className="overflow-hidden py-0">
        {post.image_url ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={post.image_url}
            alt={post.title}
            className="h-52 w-full object-cover"
            loading="lazy"
          />
        ) : null}

        <CardHeader className="gap-3 p-6">
          <p className="text-sm text-muted-foreground">
            {new Intl.DateTimeFormat("en-US", { dateStyle: "medium" }).format(
              typeof post.published_at === "string"
                ? new Date(post.published_at)
                : post.published_at,
            )}
          </p>
          <CardTitle className="font-serif text-2xl leading-tight">
            {post.title}
          </CardTitle>
        </CardHeader>

        <CardContent className="space-y-4 p-6 pt-0">
          {excerpt ? <p className="text-muted-foreground">{excerpt}</p> : null}
          <div className="flex flex-wrap gap-2">
            {post.tags.map((tag) => (
              <Badge key={`${post.id}-${tag}`} variant="outline">
                {tag}
              </Badge>
            ))}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
